import React from "react";

import { useTranslation } from "src/hooks/translation";
import { IDefer } from "src/constants/interfaces";

import "./style.scss";

interface IProps {
	defer: IDefer<boolean>;
}

const BoostOddPopup = ({ defer }: IProps) => {
	const t = useTranslation();

	return (
		<div className="B-popup-content B-popup-small B-Boosted-odd">
			<h3 className="B-popup-title">{t("Profit Boost")}</h3>
			<div className="B-popup-main-content">
				<i className="global-icon icon-boost-gift B-icon" />
				<p className="B-profit-boost-desc">
					{t("You have an unused Profit Boost. Would you like to use it now?")}
				</p>
			</div>
			<button className="B-popup-cancel-button" onClick={() => defer.resolve(false)}>
				{t("Cancel")}
			</button>
			<button className="B-popup-confirm-button" onClick={() => defer.resolve(true)}>
				{t("use boosted odds")}
			</button>
		</div>
	);
};

export default BoostOddPopup;
